import React from 'react'

export const RenderLoadingPage = () => {
  return (
    <div className="page-body__section">
      <div className="loader-container">
        <wb-spinner mode="dark" />
      </div>
    </div>
  )
}
